import requests from "./httpService";

const API_URL = "api/employees/";

// Create a new employee
const createEmployee = async (storeId, employeeData) => {
  const response = await requests.post(API_URL, { ...employeeData, storeId });
  return response;
};

// Get employees by store
const getEmployees = async (storeId) => {
  const response = await requests.get(`${API_URL}${storeId}`);
  return response;
};

// Update an employee
const updateEmployee = async (employeeId, employeeData) => {
  const response = await requests.put(`${API_URL}${employeeId}`, employeeData);
  return response;
};

// Delete an employee
const deleteEmployee = async (employeeId) => {
  const response = await requests.delete(`${API_URL}${employeeId}`);
  return response;
};

const EmployeeServices = {
  createEmployee,
  getEmployees,
  updateEmployee,
  deleteEmployee,
};

export default EmployeeServices;
